<app-grid
    selectBy="row"
    [data]="query()"
    [buttons]="buttons"
    [nrOfActiveFilters]="nrOfActiveFilters"
    [cols]="columns"
    [parentRoute]="parentRoute"
    [defaultViewMode]="defaultViewMode"
    [sortable]="true"
    [reorderable]="true"
    [resizable]="true"
    [selectable]="true"
    [autoFitColumns]="true"
    [queryData]="search"
    [selection]="selection"
    (saveGridSettings)="saveGridSettings($event)"
    (deleteGridSettings)="deleteGridSettings()"
    (selectedKeysChange)="onSelectedKeysChange($event)"
    (clearFilter)="clearFilter()"
    (toggleFilter)="filterDialog(filterProperties)" />
